import { useLogger } from '@booksy-com/vue-tools'

export default function (route, from, next) {
  const logger = useLogger('router.guard.parse-params-object')
  logger.debug(route.path)

  if (route.params) {
    for (const [key, value] of Object.entries(route.params)) {
      if (typeof value === 'string') {
        try {
          if (
            (value.startsWith('{') && value.endsWith('}'))
            || (value.startsWith('[') && value.endsWith(']'))
          ) {
            route.params[key] = JSON.parse(value)
          }
        } catch (e) {
          console.warn('Failed to parse JSON in param in path',
            {
              path: route.path,
              key: key,
              error: e.message,
            }
          )
        }
      }
    }
  }

  next()
}
